import { render, staticRenderFns } from "./BaseDropDown.vue?vue&type=template&id=f137216a"
import script from "./BaseDropDown.vue?vue&type=script&lang=js"
export * from "./BaseDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports